import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 3C0BD546-A778-4BDC-A30A-A627D61CBA47
 * name flag-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/flag-outline.svg
 * tags
 */
export const FlagOutlineIcon = createSvgIcon(<><path d="M12.36,6L12.76,8H18V14H14.64L14.24,12H7V6H12.36M14,4H5V21H7V14H12.6L13,16H20V6H14.4" /></>, 'FlagOutlineIcon');
export default FlagOutlineIcon